import { Component, OnInit } from '@angular/core';
import { NewEnvelopeService } from 'src/app/envelope/new-envelope/new-envelope.service';
import { NewEnvelopeSteps } from 'src/app/enum/new-envelope-steps';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { IToast, ToastService } from 'codex-lib';
import { SurvicateService } from 'src/app/services/survicate.service';
import { TranslateService } from '@ngx-translate/core';
import { MainEnvelopeComponent } from 'src/app/main-envelope/main-envelope.component';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';

@Component({
  selector: 'app-signatory-information',
  templateUrl: './signatory-information.component.html',
  styleUrls: ['./signatory-information.component.scss']
})

export class SignatoryInformationComponent implements OnInit {
  signatoryInformation: any;
  filteredElements: any;
  reminderFrequency: string;
  blankSlateSearch: any;
  valueSearch: string;
  isOrdered: boolean;
  settings: any;
  canSendWhatsApp: boolean = false;
  isSignFreemium: boolean = false;
  isSendWhatsapp: boolean = false;

  constructor(
    private newEnvelopeService: NewEnvelopeService,
    private translateService: TranslateService,
    private survicateService: SurvicateService,
    private toastService: ToastService,
    private mainEnvelopeComponent: MainEnvelopeComponent,
    private googleAnalitycsService: AnalyticsService) {
  }

  ngOnInit() {
    this.canSendWhatsApp = this.mainEnvelopeComponent.canSendWhatsApp;
    this.isSendWhatsapp = this.mainEnvelopeComponent.isSendWhatsapp;
    this.isSignFreemium = this.survicateService.isSignFree();
    this.signatoryInformation = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory);
    this.signatoryInformation
      .elements
      .forEach(e => {
        e.ssnWithMask = e.ssn ? CPFCNPJUtil.obfuscateCpfCnpj(CPFCNPJUtil.formatSsn(e.ssn)) : '';
        e.sendWhatsApp = false;
      });

    this.settings = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Settings).value;
    this.filteredElements = this.signatoryInformation['elements'];
    this.isOrdered = this.signatoryInformation.isOrdered;
    this.blankSlateSearch = {
      icon: {
        prefix: 'fad',
        iconName: 'search-minus'
      },
      buttonText: 'cleanSearch'
    };
  }

  onSearch(textToSearch) {
    this.valueSearch = textToSearch;
    if (textToSearch) {
      this.filteredElements = this.signatoryInformation['elements'].filter(item =>
        Object.keys(item).some(
          k =>
            item[k] != null &&
            item[k]
              .toString()
              .toLowerCase()
              .includes(textToSearch.toLowerCase())
        )
      );
    } else {
      this.filteredElements = this.signatoryInformation['elements'];
    }
  }

  onBlankSlateSearchClick = () => this.onSearch('');

  needSendWhatsapp(value: boolean, signatoryId: any) {
    this.googleAnalitycsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
        'Signer_NovEnv_Revisar_WA_Signatarios',
        value ? 'Ativo' : 'Inativo'
      )
    );

    this.filteredElements.find(x => x.id === signatoryId).sendWhatsApp = value;
  }

  toastWhatsFree() {
    const toast: IToast = {
      text: this.translateService.instant('contacts.acceptWhatsappSignFreeToast'),
      autoHide: true,
    };
    this.toastService.createNewToast(toast);
  }

  handleToggleClick(event: Event) {
    if (!this.canSendWhatsApp && !this.isSignFreemium) {
      event.preventDefault();
      event.stopPropagation();
      this.toastCantSendWhatsapp();
    }
  }

  toastCantSendWhatsapp() {
    const toast: IToast = {
      text: this.translateService.instant('contacts.sendMessageWhatsappDisabled'),
      autoHide: true,
    };
    this.toastService.createNewToast(toast);
  }
}
